import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as ssapiOperations,
  selectors as ssapiSelectors,
} from 'store/ssapiManager'
import { Formik } from 'formik'
import { validationSchema, fieldNameSets } from './data'

import SummaryModalComponent from './component'

export const SummaryModalContainer = ({
  fetchPublishFlows,
  flowLabel,
  hasApiError,
  handleClose,
  modals,
  siteId,
  preferences,
}) => {
  const goal3HasValues =
    !!preferences?.goal3Text && preferences.goal3TextIsCompleted
  const goal4HasValues =
    !!preferences?.goal4Text && preferences.goal4TextIsCompleted
  const goal5HasValues =
    !!preferences?.goal5Text && preferences.goal5TextIsCompleted

  const showGoal3 = goal3HasValues || goal4HasValues || goal5HasValues
  const showGoal4 = goal4HasValues || goal5HasValues
  const showGoal5 = goal5HasValues

  const [currentStep, setCurrentStep] = useState(0)

  const handleStepChange = toStep => setCurrentStep(toStep)

  const closeModal = () => {
    handleClose()
    fetchPublishFlows(siteId)
  }

  const initialValues = {
    ...preferences,
    programStartDate: new Date(preferences?.programStartDate) || null,
    classCreationGoalDate: preferences?.classCreationGoalDate
      ? new Date(preferences.classCreationGoalDate)
      : null,
    lessonCompletionGoalDate: preferences?.lessonCompletionGoalDate
      ? new Date(preferences.lessonCompletionGoalDate)
      : null,
    showGoal3,
    showGoal4,
    showGoal5,
    goal3Date: preferences?.goal3Date ? new Date(preferences.goal3Date) : null,
    goal4Date: preferences?.goal4Date ? new Date(preferences.goal4Date) : null,
    goal5Date: preferences?.goal5Date ? new Date(preferences.goal5Date) : null,
  }

  return (
    <Formik
      initialValues={initialValues}
      validateOnMount
      validationSchema={validationSchema}
    >
      {({ values, errors, touched, isSubmitting, isValid, resetForm }) => (
        <SummaryModalComponent
          currentStep={currentStep}
          errors={errors}
          flowLabel={flowLabel}
          goBack={() => {
            handleStepChange(0)
            resetForm()
          }}
          handleClose={closeModal}
          handleNextButtonClick={async () => {
            closeModal()
          }}
          handleStepChange={handleStepChange}
          hasApiError={hasApiError}
          isSubmitting={isSubmitting}
          isValid={isValid}
          modals={modals}
          preferences={preferences}
          siteId={siteId}
          touched={touched}
          values={values}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state, ownProps) => {
  const currentYear = new Date().getFullYear()
  const schoolYearLabel = `${String(currentYear - 1)}-${String(currentYear)}`
  const publishFlows = ssapiSelectors.selectPublishFlowsBySiteId(
    state,
    ownProps.siteId,
  )
  const publishFlow =
    publishFlows?.find(flow => flow.name === schoolYearLabel) || {}
  const preferences = {}
  fieldNameSets.forEach(fieldNameSet => {
    fieldNameSet.forEach(fieldName => {
      const preference = publishFlow?.publishFlowItems?.find(
        item => item.name === fieldName,
      )
      preferences[fieldName] =
        preference?.completeValue || preference?.draftValue || null
    })
  })
  return {
    preferences,
  }
}

const mapDispatchToProps = {
  fetchPublishFlows: ssapiOperations.fetchPublishFlows,
}

SummaryModalContainer.propTypes = {
  fetchPublishFlows: PropTypes.func,
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
  preferences: PropTypes.object,
  siteId: PropTypes.number,
}

const mapper = entry => {
  const { modalFlows } = entry || {}
  if (!modalFlows) return {}
  const modals = [
    modalFlows?.[4]?.modals?.[0] || {},
    modalFlows?.[0]?.modals?.[0] || {},
    modalFlows?.[1]?.modals?.[1] || {},
    modalFlows?.[2]?.modals?.[1] || {},
    modalFlows?.[3]?.modals?.[0] || {},
  ]

  modals[0].flowLabel = modalFlows?.[4]?.flowLabel
  modals[1].flowLabel = modalFlows?.[0]?.flowLabel
  modals[2].flowLabel = modalFlows?.[1]?.flowLabel
  modals[3].flowLabel = modalFlows?.[2]?.flowLabel
  modals[4].flowLabel = modalFlows?.[3]?.flowLabel

  return {
    modals,
  }
}

const options = {
  entryId: '7o0HkKLT0Cy171nqL7l4Ib',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    SummaryModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
